export default "__VITE_ASSET__a0378a6e__"